import { z } from 'zod'

/* A side between a pocket book and a folio, to the thousandth of an inch a
   printer's trim sizes are quoted in. */
const trimSide = z.number().finite().min(2).max(20).multipleOf(0.001)

/** A book's finished page size, in inches, both sides stated together. */
export const bookTrimSchema = z.strictObject({
  width: trimSide,
  height: trimSide,
})

export type BookTrim = z.infer<typeof bookTrimSchema>
